import React, { useEffect, useState } from 'react';
import { Link } from 'gatsby';

const STORAGE_KEY = 'analytics-notice-dismissed';

const AnalyticsNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      if (!sessionStorage.getItem(STORAGE_KEY)) {
        setVisible(true);
      }
    } catch {
      // sessionStorage unavailable — don't show
    }
  }, []);

  const dismiss = () => {
    try {
      sessionStorage.setItem(STORAGE_KEY, '1');
    } catch {
      // ignore
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="analytics-notice" role="region" aria-label="Analytics notice">
      <div className="container d-flex flex-wrap align-items-center justify-content-between gap-2">
        <p className="mb-0 small">
          This site uses privacy-friendly, cookie-free analytics.
          No personal data is stored.{' '}
          <Link to="/privacy" className="analytics-notice-link">Privacy policy</Link>
        </p>
        <button
          type="button"
          className="analytics-notice-dismiss btn-close btn-close-white"
          aria-label="Dismiss analytics notice"
          onClick={dismiss}
        />
      </div>
    </div>
  );
};

export default AnalyticsNotice;
